// extracted by mini-css-extract-plugin
export default {"Comparison":"topic-comparison_Comparison__qxFNG"};